import classes from "./message-component-styles.module.css";

export function TypingEllipsis() {
    return (
        <span className={classes.typing_ellipsis}>
            <span>.</span>
            <span className={classes.dot2}>.</span>
            <span className={classes.dot3}>.</span>
        </span>
    );
}
